<script setup>
defineProps({
  contentPadding: { type: Boolean, default: true },
})
</script>

<template>
  <div class="std-layout">
    <div class="std-safe-top" aria-hidden="true" />
    <div v-if="$slots.header" class="std-header">
      <slot name="header" />
    </div>
    <main class="std-content" :class="{ 'std-content--padded': contentPadding }">
      <slot />
    </main>
    <div v-if="$slots.footer" class="std-footer">
      <slot name="footer" />
    </div>
    <div class="std-safe-bottom" aria-hidden="true" />
  </div>
 </template>

<style scoped>
.std-layout { position: fixed; inset: 0; width: 100%; height: 100%; display: flex; flex-direction: column; overflow: hidden; }
.std-safe-top { flex-shrink: 0; height: calc(var(--tg-safe-area-top, 0px) + var(--tg-content-safe-area-top, 0px)); }
.std-header { flex-shrink: 0; padding-left: var(--tg-safe-area-left, 0px); padding-right: var(--tg-safe-area-right, 0px); }
.std-content { flex: 1; min-height: 0; overflow-y: auto; overflow-x: hidden; -webkit-overflow-scrolling: touch; padding-left: var(--tg-safe-area-left, 0px); padding-right: var(--tg-safe-area-right, 0px); }
.std-content--padded { padding-left: calc(var(--tg-safe-area-left, 0px) + 4px); padding-right: calc(var(--tg-safe-area-right, 0px) + 4px); }
.std-footer { flex-shrink: 0; padding-left: var(--tg-safe-area-left, 0px); padding-right: var(--tg-safe-area-right, 0px); }
.std-safe-bottom { flex-shrink: 0; height: var(--tg-safe-area-bottom, 0px); }
</style>
